// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
export const EMPTY_FUNCTION = (..._args: unknown[]) => {};
